import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/user-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-70bcf695"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-info-wrapper" }
const _hoisted_2 = { class: "row-data d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Type", -1))
const _hoisted_4 = { class: "data d-flex align-items-center" }
const _hoisted_5 = { class: "row-data d-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Followers", -1))
const _hoisted_7 = { class: "data d-flex align-items-center" }
const _hoisted_8 = { class: "followers-wrapper" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: "user-icon",
  width: "24",
  height: "24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_user_selection = _resolveComponent("user-selection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.content.taskType), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_user_selection, {
            selectedUsers: _ctx.computedFollowers,
            "onUpdate:selectedUsers": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedFollowers) = $event)),
            label: "Select Followers",
            exactlyOne: false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFollowers, (follower) => {
                return (_openBlock(), _createBlock(_component_LogoAndName, {
                  key: follower,
                  user: follower,
                  smallAvatarSize: true
                }, null, 8, ["user"]))
              }), 128)),
              (!_ctx.computedFollowers[0])
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selectedUsers"])
        ])
      ])
    ])
  ]))
}